import React, { useContext, useEffect, useState } from 'react';
import { store } from './Customer';
import { store as mainStore } from '../../../../../../store';
// import { DataGrid, isPageKeys } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { localText } from '../../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { __ } from '../../../../../../utils/i18n';
import { useHistory, useParams } from 'react-router-dom';
import NoTransactions from './NoTransactions';
import formatNumber from '../../../../../../fns/formatNumber';
import { useMediaQuery } from '@material-ui/core';
import DataGrid from 'components/DataGrid/DataGrid';
import { useSearchParams } from 'hooks/useSearchParams';
import { useMainStore } from 'useStores/useMainStore';

const Transactions = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { state, dispatch } = useContext(store);
  const { fetchingTransactions } = state;
  const isMobile = useMediaQuery('(max-width:1350px)');
  const limit = useMainStore((state) => state.limit);
  const [params, setParams] = useSearchParams();
  let { transactions } = state;
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
  } = useContext(mainStore);
  const columns = [
    {
      field: 'creator',
      headerName: 'ایجادکننده',
      width: 150,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'amount',
      headerName: 'مبلغ',
      width: 150,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'transactionType',
      headerName: 'نوع تراکنش',
      width: 150,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'description',
      headerName: 'شرح',
      flex: 1,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'createdAt',
      headerName: 'زمان',
      width: 180,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 180,
      renderCell: ({ value }) => value,
      // cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
  ];
  const history = useHistory();

  const getStatus = (type, isDepo, verified, paidAt) => {
    if (type === 'payCommission') return 'تسویه پورسانت';
    if (isDepo && !verified) return 'در انتظار تخلیه‌';
    if (isDepo && verified && !paidAt) return 'قابل پرداخت';
    if (isDepo && verified && paidAt) return 'پرداخت شده';
  };

  const getTransactions = async () => {
    setLoading(true);
    const res = await fetchingTransactions(
      id,
      params.get('transactionPage'),
      limit
    );
    setLoading(false);
    dispatch({ type: 'LOAD', payload: { name: 'transactions', value: res } });
  };

  const handlePageChange = async (page) => {
    setParams([{ name: 'transactionPage', value: page }]);
  };

  const _transactions =
    transactions?.docs?.map((t) => ({
      id: t._id,
      creator: `${t.creator.firstName} ${t.creator.lastName}`,
      amount: formatNumber(t.amount),
      transactionType: __(t.transactionType),
      description: t.description,
      createdAt: moment(t.createdAt).format('jYY/jMM/jDD hh:mm a'),
      status: getStatus(
        t.transactionType,
        t.isDepositCommission,
        t.verified,
        t.paidAt
      ),
    })) || [];

  useEffect(() => {
    getTransactions();
  }, [params.get('transactionPage'), limit]);

  return (
    <>
      <h4>ریز تراکنش‌ها:</h4>
      <div
        style={{
          height: !isMobile ? 300 : 400,
          width: '100%',
          marginBottom: isMobile ? 100 : 0,
          overflowY: isMobile ? 'auto' : 'unset',
        }}
      >
        {transactions ? (
          <DataGrid
            rows={_transactions}
            columns={columns}
            localeText={localText}
            rowCount={
              transactions && transactions.totalDocs
                ? transactions.totalDocs
                : 0
            }
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={loading}
            disableMultipleSelection
            density="compact"
            pageSize={Number(limit)}
            disableSelectionOnClick
            components={{
              NoRowsOverlay: NoTransactions,
            }}
            pageNumber={
              params.get('transactionPage')
                ? Number(params.get('transactionPage'))
                : 1
            }
            footerPagination={true}
            totalPages={transactions?.totalPages}
            defaultPage={params.get('transactionPage') * 1 || 1}
          />
        ) : (
          <Skeleton height={300} variant="rect" animation="wave" />
        )}
      </div>
    </>
  );
};

export default React.memo(Transactions);
